import type { AccidentFeatureConfig } from '../../../types/insurances/AccidentFeatureConfig';

export const accident: AccidentFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
            showPackage: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
    settings: {
        details: {
            showStatus: false,
        },
    },
};
